export const FilterIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.44444 4H11.5556C11.6734 4 11.7865 4.04757 11.8698 4.13224C11.9532 4.21691 12 4.33175 12 4.45149V5.16756C12 5.2873 11.9531 5.40212 11.8698 5.48677L9.01911 8.38265C8.93576 8.4673 8.88891 8.58212 8.88889 8.70185V11.5485C8.88889 11.6171 8.87348 11.6849 8.84385 11.7465C8.81422 11.8082 8.77113 11.8622 8.71787 11.9044C8.66461 11.9467 8.60258 11.976 8.53648 11.9902C8.47039 12.0044 8.40198 12.0031 8.33644 11.9865L7.44756 11.7607C7.35145 11.7363 7.26614 11.6799 7.20518 11.6005C7.14422 11.5212 7.11111 11.4234 7.11111 11.3228V8.70185C7.11109 8.58212 7.06424 8.4673 6.98089 8.38265L4.13022 5.48677C4.04687 5.40212 4.00003 5.2873 4 5.16756V4.45149C4 4.33175 4.04683 4.21691 4.13017 4.13224C4.21352 4.04757 4.32657 4 4.44444 4Z"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
